module.exports = __webpack_public_path__ + "static/img/lifestyle_31.045951b8.png";